import { Stack } from "@volca/ui/components/ui/stack";
import { TurnFailure } from "@/payroll/editor/editor-conversation/turn-failure";
import type { RequestOutcome as Outcome } from "@/payroll/editor/types";
import { CheckProblems } from "./check-problems";

export const RequestOutcome = ({
  outcome,
  request,
  onResend,
  disabled,
}: {
  outcome: Outcome;
  request: string;
  onResend: (request: string) => void;
  disabled: boolean;
}) => (
  <Stack gap={1} align="stretch" className="mt-2 text-xs">
    <p className="font-semibold">{outcome.title}</p>
    {outcome.note && <p className="text-subtle">{outcome.note}</p>}
    {outcome.result && <CheckProblems result={outcome.result} />}
    {(outcome.retry || outcome.support) && (
      <TurnFailure
        request={request}
        detail={
          outcome.note ??
          "A payroll rules request did not finish. Review the proposal for any changes already saved."
        }
        onResend={outcome.retry ? onResend : undefined}
        disabled={disabled}
      />
    )}
  </Stack>
);
